import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

import {stategame} from '@/states/game.js';

// @TODO
class ScriptCoreTree extends HYPERCUBEJS.Script {

    constructor() {

        super();
    }

    /**
     *
     * @param {*} $timebeforecollision
     * @param {HYPERCUBEJS.Node} $entity
     */
    oncollide($timebeforecollision, $entity) {

        stategame.setstate({

            ...stategame.getstate(),
            'tree': true
        });

        $entity.parent.removechild($entity);
    }

    ondestroy($entity) {

        $entity.audio.pause();
    }

    onstart($entity) {

        $entity.audio.play();
        $entity.audio.loop = true;
    }

    /**
     *
     * @param {*} $timeframe
     * @param {HYPERCUBEJS.Node} $entity
     */
    ontick($timeframe, $entity) {

        const pertick = $timeframe / 1000;

        $entity.rotate(HYPERCUBEJS.QUATERNION.fromeuler([
            0,
            HYPERCUBEJS.CONSTANTS.RADIANS * 180 * pertick,
            0
        ]));
    }
}

export {

    ScriptCoreTree
};

export default ScriptCoreTree;
